/**
 * Created by jonas on 2022-06-15.
 */
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {BS2} from "../../../BS2";
import {BS2Sound} from "../../../config/sound/BS2Sound";
import {ReelUtils} from "../../../utils/ReelUtils";



export class CollapsePresentation implements SimplePresentation {
    name:string = "CollapsePresentation";

    constructor() {
    }

    shouldRun():boolean {
        return !BS2.model.gameData.brokeTheBank;
    }

    start(controller:SimplePresentationRunnerController):void {

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => {
            controller.finish();
        }});
        tl.add(() => controller.setSkipCallback());

        tl.add(BS2.reelView.reels[0].model.collapse( ReelUtils.symbolStopFillUp), "<");
        tl.add(BS2.reelView.reels[1].model.collapse( ReelUtils.symbolStopFillUp), "<");
        tl.add(BS2.reelView.reels[2].model.collapse( ReelUtils.symbolStopFillUp), "<");
        tl.add(BS2.reelView.reels[3].model.collapse( ReelUtils.symbolStopFillUp), "<");
        tl.add(BS2.reelView.reels[4].model.collapse( ReelUtils.symbolStopFillUp), "<");

        tl.to(this, {duration:0.2});

    }
}